import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import "./style.scss";
export default class QuoteContent extends Component {
  QuoteContent(model) {
    const {
      paddingAboveTop,
      paddingAboveBottom,
      gridType,
      backgroundColor,
      alignment,
      barColor,
      iconName,
      quote,
      author
    } = model.fields;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "default";
    const quoteClasses = classNames(
      "quote-content",
      "padding-top-" + top,
      "padding-bottom-" + bottom,
      {
        "grid-story": gridType && gridType.fields.phrase.value === "story",
        grid: gridType && gridType.fields.phrase.value === "normal"
      }
    );

    const backgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : ""
    };
    let alignmentClass = alignment ? alignment.fields.phrase.value : "";
    const contentClasses = classNames("content", alignmentClass);
    let authorBorderStyle = {
      borderColor: barColor && barColor.fields && barColor.fields.phrase.value
    };
    let icon = {};
    if (iconName && iconName.value && iconName.value.alt) {
      icon = iconName.value.alt;
    }
    return (
      <div
        className={quoteClasses}
        style={backgroundStyle}
        datasourceid={this.props.rendering.dataSource}
      >
        <div className={contentClasses}>
          {iconName && iconName.value && iconName.value.alt && (
            <RichText
              className={"quote-icon"}
              tag="div"
              field={{ value: icon }}
            />
          )}
          <RichText tag="span" className={"title"} field={quote} />
          <div className={"author-box"}>
            <div className={"line"} style={authorBorderStyle} />
            {author && author.value && (
              <RichText tag="span" className={"author-name"} field={author} />
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    let model = this.props;
    let { gridType } = model.fields;
    if (gridType && gridType.fields.phrase.value === "story") {
      return <div className={"grid"}>{this.QuoteContent(model)}</div>;
    } else {
      return this.QuoteContent(model);
    }
  }
}
